import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isFeedbackOpen: false,
};

const feedBackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    setFeedBackOpened(state, action) {
      state.isFeedbackOpen = action.payload; // 🔁 use payload (true or false)
    },
  },
});

export const { setFeedBackOpened } = feedBackSlice.actions;
export const selectIsFeedbackOpen = (state) => state.feedback.isFeedbackOpen;
export default feedBackSlice.reducer;
